import type { ViewjobQuery } from "../__generated__/viewjob.gqlgenerated";

/**
 * Maps `ViewJobDetails.relatedLinks` onto the related-links model.
 *
 * `what` and `where` are nullable on the graph but optional on the model, so
 * they are normalized to `undefined`. An empty list is passed through as an
 * empty array — `RelatedLinks` already renders nothing for it — and `undefined`
 * is reserved for "the graph returned no related links at all".
 */
export const buildRelatedLinks = (
  viewjob: NonNullable<ViewjobQuery["viewjob"]>,
): component.relatedlinks.RelatedLinksModel[] | undefined => {
  const relatedLinks = viewjob.details?.relatedLinks;

  if (!relatedLinks) {
    return undefined;
  }

  return relatedLinks.map((link) => ({
    href: link.href,
    linkText: link.linkText,
    what: link.what ?? undefined,
    where: link.where ?? undefined,
  }));
};
